import { envManager, env } from '@accor/customer-core'
import { DEFAULT_API_KEY } from '@/constants/secrets'
import { getTokenErrorHandler } from '@/services/getTokenErrorHandler'
import { AdsLink } from '@accor/ads-components'
import { configure as customerApiConfigure } from '@accor/customer-api/cloud'
import { i18nService } from '@accor/customer-vue-services'
import { isWebView } from '@accor/customer-api/cloud'

const prodConfig = {
  name: 'prod',
  apiKey: DEFAULT_API_KEY,
  isBeaconMCPScriptEnabled: true,
  isOneTrustEnabled: true,
  apiAem: 'https://aem-api.accor.com',
  permalinkSignUp: 'https://permalink.accor.com/authentication/sign-up',
  apiAccorComApi: 'https://api.accor.com',
  dynatraceScriptUrl: false,
  gtmId: 'GTM-TKQN7D',
  //prevent RUM in E2E tests
  splunkRUM:
    window.location.hostname != 'localhost'
      ? {
          realm: 'eu0',
          rumAccessToken: 'qjAa80AoNS_2SxXhfJl8QQ',
          applicationName: 'ALL_ACCOR_CUACC',
          cookieDomain: 'accor.com',
          globalAttributes: {
            leanix_id: '1B9525A9-297A-4BF9-9AFF-DCF77AF4C129',
            snow_id: '1357A18B87D0B51C8A4664E70CBB35DB',
            itdomain: 'D2_LOYALTY_AND_PARTNERSHIPS',
            itdepartment: 'PRODUCT_ENGINEERING_AND_DELIVERY',
            pci: 'FALSE',
            critical_biz: 'C1'
          }
        }
      : false,
  splunkSessionRecorder: false,
  isABTestingEnabled: true
}

export const configureEnv = async () => {
  await envManager.configure(
    'all.accor.com',
    { ...prodConfig, isOneTrustEnabled: !isWebView() },
    {
      i18nService,
      getTokenErrorHandler,
      linkComponent: AdsLink,
      getAppVersion: () => __APP_VERSION__,
      basePath: 'account'
    },
    `${import.meta.env.BASE_URL}config.json`
  )

  customerApiConfigure(env.config)
}
